/**
 * What view a chat window should be displaying.
 *
 * This enum applies to the standalone desktop window and mobile chat modal.
 */ export var ChatWindowMode;
(function(ChatWindowMode) {
    ChatWindowMode["DEFAULT"] = "default";
    ChatWindowMode["RENAME"] = "rename";
    ChatWindowMode["REMOVE"] = "remove";
    ChatWindowMode["CREATE_GROUP_CHAT"] = "create_group_chat";
    ChatWindowMode["MANAGE"] = "manage";
    ChatWindowMode["LEAVE"] = "leave";
    ChatWindowMode["LOADING"] = "loading";
    ChatWindowMode["ERROR"] = "error";
    /** This state is only used for the floating chat windows on desktop */ ChatWindowMode["MINIMIZED"] = "minimized";
    /** A special case that doesn't pull a chatroom from the store */ ChatWindowMode["NEW"] = "new";
})(ChatWindowMode || (ChatWindowMode = {}));
